/**
 * ⚡ v4.89 (perf review #5): the current version lives in its own tiny
 * module so the GameMenu (mounted on every screen) and the title
 * screen's changelog summary don't drag the whole 250KB CHANGELOG
 * array into the entry chunk for one string. The changelog itself is
 * lazy-loaded when the player opens the panel.
 *
 * RELEASE RULE: bump this with every release — the newest changelog
 * entry imports it as its `version`, so the two can never drift.
 */
export const CURRENT_VERSION = 'v8.06'
